/* eslint-disable no-param-reassign */
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Toggle from 'material-ui/Toggle';
import ClinicianLocator from '../ClinicianLocator/ClinicianLocator';
import Spinner from '../../common/Spinner/Spinner';
import globals from '../../../globals/communityGlobals';
import CliniciansList from '../CliniciansList/CliniciansList';
import Timeline from '../Timeline/Timeline';
import AlertBox from '../../common/AlertBox/AlertBox';
import posting from '../../../propTypes/entities/posting';
import locationsForPosting from '../../../propTypes/entities/locationsForPosting';
import { refreshTimeInSeconds } from '../../../settings/scheduler';
import { appSettingsPropTypes, appSettingsDefault } from '../../../propTypes/entities/appSettings';
import { toggleGrey } from '../../../theme/AllocateBaseTheme';
import { getSchedulerModeTimes } from '../../../utils/dates';

const locale = globals.getArea('dailyPlanning');
const styles = {
  anchorOrigin: { horizontal: 'left', vertical: 'top' },
  targetOrigin: { horizontal: 'left', vertical: 'top' },
  listStyle: { minHeight: '129px' },
};

class Scheduler extends React.Component {
  constructor(props) {
    super(props);
    this.interval = null;

    this.state = {
      isRefreshing: true,
      createLog: false,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.tick(), refreshTimeInSeconds * 1000);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      mapViewState,
      failureMessage,
      postings,
      locationsForPostings,
      isFetching,
      isAutoAllocating,
      autoAllocateDate,
      autoAllocateTeamId,
      selectedTeam,
      selectedDate,
      selectedClinicianId,
      downloadingPlan,
      dayStart,
      dayEnd,
    } = this.props;
    return (
      dayStart !== nextProps.dayStart ||
      dayEnd !== nextProps.dayEnd ||
      mapViewState !== nextProps.mapViewState ||
      this.state.createLog !== nextState.createLog ||
      failureMessage !== nextProps.failureMessage ||
      isFetching !== nextProps.isFetching ||
      isAutoAllocating !== nextProps.isAutoAllocating ||
      autoAllocateDate !== nextProps.autoAllocateDate ||
      autoAllocateTeamId !== nextProps.autoAllocateTeamId ||
      selectedDate !== nextProps.selectedDate ||
      selectedTeam !== nextProps.selectedTeam ||
      selectedClinicianId !== nextProps.selectedClinicianId ||
      downloadingPlan !== nextProps.downloadingPlan ||
      postings.map(p => p.id).join(',') !== nextProps.postings.map(p => p.id).join(',') ||
      locationsForPostings.map(p => p.id).join(',') !== nextProps.locationsForPostings.map(p => p.id).join(',') ||
      this.state.isRefreshing
    );
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setCreateLog = () => {
    const { createLog } = this.state;
    this.setState({
      createLog: !createLog,
    });
    this.props.setAutoAllocationLogSetting(!createLog);
  };

  getSchedulerModeTime = isDayMode => {
    const { appSettings, dayStart } = this.props;
    let hours = isDayMode ? appSettings.SchedulerDayModeStartTime : appSettings.SchedulerNightModeStartTime;
    hours = hours || '00';

    return moment(dayStart)
      .set({ hours })
      .utcOffset(0, true)
      .format(globals.dateFormats.localApiFormat);
  };

  showMap = () => {
    this.props.fetchLocationsForPostings();
    this.props.changeSchedulerMapView(true);
  };

  generateOpacity = requestInProgress => ({ opacity: requestInProgress && '0.4' });

  showScheduler = () => {
    this.props.changeSchedulerMapView(false);
  };

  tick() {
    const { isRefreshing } = this.state;

    if (!this.props.isAutoAllocateInProgress && isRefreshing && this.isTodayWithStartTime()) {
      if (this.props.mapViewState) {
        this.props.fetchLocationsForPostings();
      } else {
        const { selectedDate, appSettings, isNightMode } = this.props;
        this.props.fetchPostings(
          true,
          true,
          isNightMode,
          selectedDate,
          appSettings.SchedulerDayModeStartTime,
          appSettings.SchedulerNightModeStartTime,
        );
      }
    }
  }

  mapIcon = (
    <IconButton className="menu-icon" iconClassName="allocateIcons">
      {' '}
      map{' '}
    </IconButton>
  );
  sheduleIcon = (
    <IconButton className="menu-icon" iconClassName="allocateIcons">
      schedule
    </IconButton>
  );
  moreVertIcon = (
    <IconButton className="iconButton" iconClassName="allocateIcons">
      more_vert
    </IconButton>
  );

  parseDate = date => moment(date).utcOffset(0, true);
  dayStartDate = () => this.parseDate(this.props.dayStart).startOf('day');
  isToday = () => this.parseDate(this.props.serverDateTime).isSame(this.dayStartDate(), 'd');
  isTodayWithStartTime = () => {
    const {
      selectedDate,
      isNightMode,
      appSettings: { SchedulerDayModeStartTime },
      appSettings: { SchedulerNightModeStartTime },
    } = this.props;
    const { schedulerStartTime, schedulerEndTime } = getSchedulerModeTimes(
      selectedDate,
      isNightMode,
      SchedulerDayModeStartTime,
      SchedulerNightModeStartTime,
    );
    return this.parseDate(this.props.serverDateTime).isBetween(schedulerStartTime, schedulerEndTime);
  };

  renderCliniciansList() {
    const { postings, selectedDate, appSettings, isFetching } = this.props;
    const hasNoData = !postings || postings.length < 1;

    if (hasNoData || isFetching) return null;

    return (
      <div>
        <div className="timeline-addition header">
          <IconMenu
            iconButtonElement={this.moreVertIcon}
            anchorOrigin={styles.anchorOrigin}
            targetOrigin={styles.targetOrigin}
            className="IconMenu"
            autoWidth
            listStyle={styles.listStyle}
          >
            <MenuItem
              primaryText="Scheduler"
              onClick={this.showScheduler}
              className="list-icon"
              leftIcon={this.sheduleIcon}
            />
            <MenuItem primaryText="Maps" onClick={this.showMap} className="list-icon" leftIcon={this.mapIcon} />
          </IconMenu>
          <h2>{locale.getMsg('cliniciansList')}</h2>
        </div>
        <CliniciansList postings={postings} appSettings={appSettings} selectedDate={selectedDate} />
      </div>
    );
  }

  render() {
    const {
      isFetching,
      isAutoAllocating,
      autoAllocateDate,
      autoAllocateTeamId,
      postings,
      dayStart,
      selectedDate,
      selectedTeam,
      locationsForPostings,
      dayEnd,
      canAllocateWork,
      failureMessage,
      mapViewState,
      selectedClinicianId,
      dismissErrors,
      appSettings,
      serverDateTime,
      downloadingPlan,
      isNightMode,
    } = this.props;
    const { isRefreshing, createLog } = this.state;
    const isAutoAllocatingForSelectedTeam =
      autoAllocateTeamId !== 0 && autoAllocateDate !== '0001-01-01'
        ? isAutoAllocating && selectedTeam === autoAllocateTeamId && selectedDate === autoAllocateDate
        : isAutoAllocating;
    const requestInProgress = isFetching || downloadingPlan || isAutoAllocatingForSelectedTeam;
    const { schedulerStartTime, schedulerEndTime } = getSchedulerModeTimes(
      selectedDate,
      isNightMode,
      appSettings.SchedulerDayModeStartTime,
      appSettings.SchedulerNightModeStartTime,
    );

    return (
      <section className="main-stage clearfix">
        <div className="main-sched sched-clearfix">
          {requestInProgress && <Spinner />}
          <div style={this.generateOpacity(requestInProgress)}>
            <section className="scheduler-content">
              <section className="scheduler-header">
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '5px' }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '0px' }}>
                        <h1 className="sub" style={{ padding: '0px', margin: '0px' }}>
                          {isNightMode ? 'Night Mode' : 'Day Mode'}
                        </h1>
                      </td>
                      {this.isTodayWithStartTime(schedulerStartTime) && (
                        <td style={{ padding: '0px', width: '150px' }}>
                          <Checkbox
                            checked={isRefreshing}
                            labelPosition="left"
                            onCheck={() => this.setState({ isRefreshing: !isRefreshing })}
                            label={locale.getMsg('liveTracking')}
                          />
                        </td>
                      )}
                      {!requestInProgress && !mapViewState && postings.length > 0 && (
                        <td style={{ padding: '0px', width: '270px' }}>
                          <Checkbox
                            checked={createLog || false}
                            labelPosition="left"
                            onCheck={this.setCreateLog}
                            label={locale.getMsg('createLog')}
                          />
                        </td>
                      )}
                      {!mapViewState && (
                        <td style={{ padding: '0px', width: '120px' }}>
                          <span style={{ float: 'right', marginTop: '3px' }}>Night</span>
                          <Toggle
                            label="Day"
                            defaultToggled={isNightMode}
                            style={{ width: '64%' }}
                            onToggle={this.props.toggleSchedulerModeView}
                            thumbStyle={toggleGrey.thumbStyle}
                            trackStyle={toggleGrey.trackStyle}
                          />
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </section>
              <AlertBox type="notification" content={failureMessage} onClick={dismissErrors} />
              <div className="scheduler-wrapper">
                {this.renderCliniciansList()}
                {mapViewState ? (
                  <ClinicianLocator
                    appSettings={appSettings}
                    postings={locationsForPostings}
                    dayStart={dayStart}
                    dayEnd={dayEnd}
                    serverDateTime={serverDateTime}
                    selectedClinicianId={selectedClinicianId}
                  />
                ) : (
                  <Timeline
                    postings={postings}
                    dayStart={schedulerStartTime}
                    dayEnd={schedulerEndTime}
                    now={serverDateTime}
                    canAllocateWork={canAllocateWork}
                    isNightMode={isNightMode}
                    isFetching={isFetching}
                    isAutoAllocating={isAutoAllocatingForSelectedTeam}
                  />
                )}
              </div>
            </section>
          </div>
        </div>
      </section>
    );
  }
}

Scheduler.defaultProps = {
  dayStart: '',
  dayEnd: '',
  selectedDate: '',
  autoAllocateDate: '',
  failureMessage: '',
  locationsForPostings: [],
  appSettings: appSettingsDefault,
  selectedClinicianId: null,
  postings: [],
  isNightMode: false,
  selectedTeam: null,
  autoAllocateTeamId: null,
};

Scheduler.propTypes = {
  mapViewState: PropTypes.bool.isRequired,
  failureMessage: PropTypes.string,
  postings: PropTypes.arrayOf(posting),
  locationsForPostings: PropTypes.arrayOf(locationsForPosting),
  canAllocateWork: PropTypes.bool.isRequired,
  fetchPostings: PropTypes.func.isRequired,
  fetchLocationsForPostings: PropTypes.func.isRequired,
  setAutoAllocationLogSetting: PropTypes.func.isRequired,
  dismissErrors: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isAutoAllocating: PropTypes.bool.isRequired,
  dayStart: PropTypes.string,
  dayEnd: PropTypes.string,
  selectedDate: PropTypes.string,
  serverDateTime: PropTypes.string.isRequired,
  appSettings: appSettingsPropTypes.isRequired,
  changeSchedulerMapView: PropTypes.func.isRequired,
  selectedClinicianId: PropTypes.number,
  downloadingPlan: PropTypes.bool.isRequired,
  isNightMode: PropTypes.bool.isRequired,
  toggleSchedulerModeView: PropTypes.func.isRequired,
  isAutoAllocateInProgress: PropTypes.bool.isRequired,
  selectedTeam: PropTypes.number,
  autoAllocateTeamId: PropTypes.number,
  autoAllocateDate: PropTypes.string,
};

export default Scheduler;
